module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Du har ohanterade kandidater i jobbet":"You have unhandled candidates in the job"},"sv":{"Du har ohanterade kandidater i jobbet":"Du har ohanterade kandidater i jobbet"}}')
  delete Component.options._Ctor
}
